<template>
    <div class="page_mobile_about flex-col">
        <div class="group_2 flex-col">

            <div class="text-wrapper_4 flex-row justify-between">
                <span class="text_12">关于我们</span>
                <span class="text_13">About&nbsp;us</span>
            </div>
            <span class="paragraph_1">
        康柏汉森深耕医药行业近二十年，是大健康领域风险控制服务的倡导者与实践者。依托全国10大运营中心，资深项目经理与执行团队以及企业健康管理智慧中心等服务优势，为大健康领域100余家全球领先企业提供全链路风控与合规管理服务。
        <br />
        <br />
        康柏汉森专注于企业业务风险诊断与合规管理，深刻理解企业经营健康与业务成长的迫切需求，为企业提供业务风控与合规管理的多样化产品以及整体服务解决方案，助力客户达成“风险可视、决策可依、增长可持续”。
      </span>
            <div class="box_about_img_wrap">
                <div class="box_about_img_inner">
                    <div class="box_about_img flex-col"></div>
                </div>
            </div>



        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {

            };
        },
        methods: {}
    };
</script>
<style scoped lang="css" >
    .page_mobile_about {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        max-width: 750px;
        overflow: hidden;
        margin: 0 auto;
    }

    .group_2 {
        width: 100%;
        max-width: 750px;
        margin: 0 auto;
        padding-left: 18px;
        padding-right: 18px;
        box-sizing: border-box;
    }

    .text-wrapper_4 {
        width: 100%;
    }

    .text_12 {
        overflow-wrap: break-word;
        color: rgba(30, 30, 30, 1);
        font-size: 20px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 45px;
    }

    .text_13 {
        overflow-wrap: break-word;
        color: rgba(204, 204, 204, 1);
        font-size: 20px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 37px;
        margin-top: 6px;
        margin-left: 10px;
    }

    .paragraph_1 {
        width: 100%;
        color: rgba(85, 85, 85, 1);
        font-size: 16px;
        font-weight: normal;
        text-align: justify;
        text-justify: inter-ideograph;
        -webkit-text-justify: inter-ideograph; /* Safari */
        line-height: 38px;
        word-break: break-word;
        box-sizing: border-box;
        margin: 0 auto;
    }

    .box_about_img_wrap {
        max-width: 750px;
        position: relative;
        overflow: hidden;
    }
    .box_about_img_inner {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .box_about_img {
        cursor: pointer;
        background-image: url(../../../assets/index/chpc_home_about.jpg);
        width: 100%;
        height: 170px;

        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        overflow: hidden;
        transition: transform 0.3s ease;
        transform-origin: center center;
        transform-box: border-box;
    }
    .box_about_img:hover {
        transform: scale(1.2);
    }

    .text-wrapper_4,
    .paragraph_1,
    .box_about_img_wrap {
    }

    /* 移动设备特定调整 */
    @media (max-width: 480px) {
        .paragraph_1 {
            font-size: 14px;
            line-height: 24px;
        }

        .text_12 {
            font-size: 20px;
        }

        .text_13 {
            font-size: 20px;
        }

        .box_about_img {
            width: calc(100% - 10px);
            margin-top: 10px;
            height: 170px;
        }
    }


</style>
